import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Collapse, Button, Modal, Alert, message } from "antd";
import moment from "moment";
import PaymentOdcModal from "./PaymentOdcModal";
import Colors from '../../../../../themes/Colors';
import {
  getGatewayLabel,
  getPaymentStatusInfo,
  getOverallPaymentInfo,
  isCampaignPaymentPending,
  hasPendingPayment,
  canCreatePayment,
  canShowOdc,
  getCreatePaymentPath,
} from "../../utils/paymentsData";

const { Panel } = Collapse;

const PaymentsCard = (props) => {
  const { t } = useTranslation();
  const { campaign, payments, deletingPayment, deletePayment, isSuperUser, user, history } = props;
  const defaultOpen = props.defaultOpen !== false;

  const noPaymentCreated = !payments || payments.length === 0;
  const overall =
    campaign.status === "proposal" && noPaymentCreated
      ? { label: t("No payment created"), color: Colors.textMuted }
      : getOverallPaymentInfo(campaign.payment_status, t);
  const allowCreate = canCreatePayment(campaign, isSuperUser);
  const campaignPending = isCampaignPaymentPending(campaign.payment_status);
  const showOdc = canShowOdc(user);

  const onDelete = (id) => {
    Modal.confirm({
      title: t("Delete payment"),
      content: t("Are you sure you want to delete this payment?"),
      okText: t("Delete"),
      cancelText: t("Cancel"),
      okType: "danger",
      onOk: () => deletePayment(id),
    });
  };

  const onCreate = () => {
    if (hasPendingPayment(payments)) {
      message.error(t("There is already a pending payment for this campaign."));
      return;
    }
    if (campaign && campaign.id && history) {
      history.push(getCreatePaymentPath(campaign));
    }
  };

  const estadoHeader = (
    <div className="payments__estado">
      <span className="payments__estado-dot" style={{ backgroundColor: overall.color }} />
      <div>
        <div className="payments__estado-label">{t("Status")}</div>
        <div className="payments__estado-value">{overall.label}</div>
      </div>
    </div>
  );

  return (
    <div className="campaignDetail__card payments">
      <div className="campaignDetail__section-title campaignDetail__map-title">{t("Your payments")}</div>
      <Collapse expandIconPosition="right" defaultActiveKey={defaultOpen ? ["1"] : []} bordered={false}>
        <Panel header={estadoHeader} key="1">
          {allowCreate ? (
            <>
              <div className="payments__table-wrap">
                <table className="payments__table">
                  <thead>
                    <tr>
                      <th>{t("Day")}</th>
                      <th>{t("Payment method")}</th>
                      <th>{t("Status")}</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {(payments || []).map((p) => {
                      const statusInfo = getPaymentStatusInfo(p.status, t);
                      return (
                        <tr key={p.id} className={deletingPayment ? "payments__row--loading" : ""}>
                          <td>{moment(p.created_at).format("DD/MM/YYYY HH:mm")}</td>
                          <td>{getGatewayLabel(p.gateway, t)}</td>
                          <td>{statusInfo.label}</td>
                          <td className="payments__actions">
                            <Link to={"/payment/" + p.id}>
                              <Button shape="circle" icon="eye" title={t("View")} />
                            </Link>
                            {p.status === "pending" && (
                              <Button
                                shape="circle"
                                icon="delete"
                                loading={deletingPayment}
                                onClick={() => onDelete(p.id)}
                                title={t("Delete")}
                              />
                            )}
                            {p.status !== "cancelled" && showOdc && (
                              <PaymentOdcModal data={campaign.purchase_order_agency} t={t} />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    {(!payments || payments.length === 0) && (
                      <tr>
                        <td colSpan={4} className="payments__empty">
                          {t("No data")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {campaignPending && (
                <Button type="primary" className="payments__create" onClick={onCreate}>
                  {t("Create new payment")}
                </Button>
              )}
            </>
          ) : (
            <div className="payments__external">
              <p>
                {t("info_payment_first")} (<strong>{campaign.external_dsp && campaign.external_dsp.name}</strong>){" "}
                {t("info_payment_second")}
              </p>
              <Alert description={t("info_payment_third")} type="info" showIcon />
            </div>
          )}
        </Panel>
      </Collapse>
    </div>
  );
};

export default PaymentsCard;
